import axios from 'axios';

export default function postGenerateHtmlFromRawData(reportType, reportData, config) {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };

    const url = config.postDataRetentionHtmlReportUrl;
    return dispatch => dispatch({
        type: 'POST_GENERATE_HTML_FROM_RAW_DATA',
        payload: axios({ method: 'post', url, headers, data: { reportType, reportData }  })
    });
}


// WEBPACK FOOTER //
// ./src/actions/postGenerateHtmlFromRawData.js